import React, { useState, useEffect } from 'react';
import { Button, message, Modal, Form, Input, List, Tag, Spin, Empty } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import api, { listInvites, createInvite } from '../services/api';

interface InviteRow {
    code: string;
    expires_at: string;
    active: boolean;
    used_by?: string;
    used_at?: string | null;
}

const MobileInviteManagePage: React.FC = () => {
    const [invites, setInvites] = useState<InviteRow[]>([]);
    const [loading, setLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const formatDateTime = (input: string): string => {
        try {
            // 统一处理常见时间格式，强制按上海时区显示，24小时制
            let s = String(input || '').trim();
            if (!s) return '';
            // 尽量转为 ISO 8601
            if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(s)) {
                // 形如 "2025-09-24 12:34:56" → 视为本地时间
                s = s.replace(' ', 'T');
            }
            const d = new Date(s);
            if (isNaN(d.getTime())) return input;
            return d.toLocaleString('zh-CN', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                hour12: false,
                timeZone: 'Asia/Shanghai'
            });
        } catch {
            return input;
        }
    };

    const fetchInvites = async () => {
        setLoading(true);
        try {
            const data = await listInvites();
            setInvites(data as any);
        } catch (error) {
            message.error('邀请码加载失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvites();
    }, []);

    const handleCreate = async () => {
        try {
            await createInvite(24);
            message.success('邀请码创建成功');
            fetchInvites();
        } catch (error: any) {
            const status = error?.response?.status;
            const detail = error?.response?.data?.detail;
            if (status === 401) {
                message.error('未登录或登录已过期，请先登录');
                window.location.href = '/matching/login';
                return;
            }
            if (status === 403) {
                message.error('无权限创建邀请码，请使用管理员账号登录');
                return;
            }
            message.error(detail || '邀请码创建失败');
        }
    };

    return (
        <div style={{ padding: '12px' }}>
            <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleCreate}
                style={{ marginBottom: '16px' }}
                block
            >
                创建邀请码
            </Button>
            
            <Spin spinning={loading}>
                {invites.length === 0 && !loading ? (
                    <Empty description="暂无邀请码" />
                ) : (
                            <List
                        dataSource={invites}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    title={item.code}
                                            description={`有效期至: ${formatDateTime(item.expires_at)}`}
                                />
                                        {item.active ? (
                                            <Tag color="green">未使用</Tag>
                                        ) : (
                                            <Tag>已使用/失效</Tag>
                                        )}
                            </List.Item>
                        )}
                    />
                )}
            </Spin>
        </div>
    );
};

export default MobileInviteManagePage;
